(function () {
	var customInput = document.getElementById('techlight-search-input');
	if (!customInput) return;

	function getModuleInput() {
		return document.querySelector('.wpc-search-field');
	}

	function getClearIcon() {
		return document.querySelector('.wpc-search-clear-icon');
	}

	// Dodaj ikonkę X do wrappera custom inputa
	var wrapper = customInput.parentElement;
	var clearBtn = document.createElement('span');
	clearBtn.className = 'techlight-search-clear';
	clearBtn.innerHTML = '&times;';
	clearBtn.style.cssText = 'display:none; position:absolute; right:12px; top:50%; transform:translateY(-50%); cursor:pointer; font-size:18px; line-height:1; color:#999;';
	wrapper.style.position = 'relative';
	wrapper.appendChild(clearBtn);

	function updateClearBtn() {
		clearBtn.style.display = customInput.value ? 'block' : 'none';
	}

	// Usuń paged z URL żeby filtry zawsze startowały od strony 1
	function resetPaged() {
		var url = new URL(window.location.href);
		if (url.searchParams.has('paged')) {
			url.searchParams.delete('paged');
			window.history.replaceState(null, '', url.toString());
		}
	}

	// Sync wartości z modułu (jeśli już coś wpisane)
	var moduleInput = getModuleInput();
	if (moduleInput && moduleInput.value) {
		customInput.value = moduleInput.value;
	}
	updateClearBtn();

	// Obsługa placeholdera z data-attribute (tłumaczenie przez WPML)
	var ph = customInput.getAttribute('data-placeholder') || (typeof techlightI18n !== 'undefined' ? techlightI18n.searchPlaceholder : 'Szukaj...');
	customInput.setAttribute('placeholder', ph);
	customInput.addEventListener('focus', function () { this.setAttribute('placeholder', ''); });
	customInput.addEventListener('blur',  function () { this.setAttribute('placeholder', ph); });

	// Wpisywanie → przepisuj do pola modułu i triggeruj jego event
	customInput.addEventListener('input', function () {
		var mod = getModuleInput();
		if (!mod) return;
		mod.value = customInput.value;
		mod.dispatchEvent(new Event('input', { bubbles: true }));
		updateClearBtn();
	});

	function triggerModuleSearch() {
		var mod = getModuleInput();
		if (!mod) return;
		resetPaged();
		mod.value = customInput.value;
		mod.dispatchEvent(new Event('input', { bubbles: true }));
		var form = mod.closest('form');
		if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
	}

	// Klik X → wyczyść i kliknij clear modułu
	clearBtn.addEventListener('click', function () {
		customInput.value = '';
		updateClearBtn();
		resetPaged();
		var modClear = getClearIcon();
		if (modClear) modClear.click();
	});

	// Enter → submit formularza modułu
	customInput.addEventListener('keydown', function (e) {
		if (e.key === 'Enter') { e.preventDefault(); triggerModuleSearch(); }
	});

	// Lupa → to samo
	var icon = wrapper.querySelector('.search-icon');
	if (icon) { icon.style.cursor = 'pointer'; icon.addEventListener('click', triggerModuleSearch); }

	// Każda zmiana filtrów w module → resetuj paged przed AJAX requestem
	document.addEventListener('click', function (e) {
		var isFilterAction =
			e.target.closest('.wpc-filters-main-wrap') &&
			!e.target.closest('.wpc-widget-close-icon') &&
			!e.target.closest('.wpc-filters-close-button') &&
			!e.target.closest('.wpc-open-close-filters-button');

		if (isFilterAction) {
			resetPaged();
		}
	});

	// Po AJAX update z Filter Everything (jQuery event "ready") – resetuj paged
	// Plugin odpala: jQuery(document).trigger("ready")
	if (typeof jQuery !== 'undefined') {
		jQuery(document).on('ready', function () {
			resetPaged();
		});
	}
}());
